import { extendTheme } from "@chakra-ui/react";
import {
    Button,
    Input,
    Select,
    Textarea,
    Checkbox,
    Radio,
    Switch,
    FormLabel,
    Modal,
    Drawer,
    Tabs,
    NumberInput,
    Badge,
} from "./components";
import { colors, typography, GlobalStyle } from "./foundations";
const fonts = typography.fonts;
const textStyles = typography.textStyles;

const overrides = {
    styles: GlobalStyle,
    colors,
    fonts,
    textStyles,
    components: {
        Button,
        Input,
        Select,
        Textarea,
        Checkbox,
        Radio,
        Switch,
        FormLabel,
        Modal,
        Drawer,
        Tabs,
        NumberInput,
        Badge,
    },
};

export default extendTheme(overrides);
